import axios from 'axios';
import type { DateTime } from 'luxon';

/**
 * UnitMaterialsService
 */
export default class UnitMaterialsService
{
    public static path = 'admin/elearning/courses/unit-materials';

    /**
     * @param unitId number
     *
     * @return Promise<Pagination<Resource<ListItemModel>>>
     */
    public static async getList(unitOriginId: number): Promise<Pagination<ListItemModel>>
    {
        return (await axios.get<Pagination<ListItemModel>>(`${this.path}/${unitOriginId}/list`)).data;
    }
}

export interface FilterModel
{
    unitId?: number;
    materialId?: number;
    isPublished?: boolean;
    dateFromUtc?: DateTime;
    dateDueUtc?: DateTime;
}

export interface ListItemModel extends PositionModel
{
    id: number;
    unitId: number;
    materialId: number;
    materialOriginId: number;
    position: number;
    isPublished: boolean;
    name: string;
    type: string;
    maxResult: number;
    isUnsaved: boolean;
    error?: boolean;
    redirectUnitOriginId: number;
    redirectMaterialOriginId: number;
}

export interface FormModel
{
    id: number | string;
    unitOriginId: number;
    materialOriginId: number;
    position: number;
    isPublished: boolean;
    redirectUnitOriginId: number;
    redirectMaterialOriginId: number;
}

export interface UnitMaterialPosition extends PositionModel
{
}

export interface PositionModel
{
    id: number | string;
    position: number;
}
